var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.65,18.46l1.13-1.13,1.25-1.25,1.3-1.29c1.82-1.81,1.86-4.73.22-6.72-1.81-2.19-5.18-2.33-7.32-.37l-1.28,1.3-1.24,1.25-1.24,1.26c-.53.53-1.29.72-1.88.16-.5-.48-.48-1.29.07-1.83l4.07-4.01c2.1-2.07,5.27-2.46,7.9-1.37,3.92,1.62,5.56,6.25,3.88,9.84-.4.85-.83,1.59-1.5,2.27l-6.67,6.7c-3.09,3.11-8.07,3.31-11.03-.03-.43-.48-.06-1.24.33-1.55.54-.42,1.17-.35,1.72.18,1.69,1.64,4.47,1.87,6.42.37.48-.37.99-.89,1.42-1.33l1.1-1.1,1.36-1.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,32.13c1.83,2.09,5.33,2,7.08.27l1.46-1.45,1.17-1.17,1.24-1.25c.52-.53,1.18-.71,1.82-.24.46.34.66,1.21.14,1.73l-3.88,3.9c-.69.69-1.44,1.17-2.36,1.58-3.42,1.53-7.62.22-9.44-3.11-1.5-2.73-1.37-6.25.85-8.51l7.01-7.12c2.95-2.99,7.58-3.28,10.66-.41.54.51.67,1.17.25,1.75-.35.49-1.19.74-1.76.18-1.79-1.78-4.76-2.08-6.76-.38l-1.11,1.05-1.25,1.25-1.25,1.25-1.24,1.24-1.25,1.25c-.43.43-.92.86-1.29,1.27-1.81,2.01-1.84,4.91-.08,6.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.9d1598940f713a018fa298a4805300ef.svg";
export { ForwardRef as ReactComponent };